var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal custom-modal fade",
      attrs: { id: "add_form", role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered modal-lg",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm.formParam.id != "" && _vm.formParam.id != null
                ? _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Edit Account")
                  ])
                : _vm.formParam.copy == true
                ? _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Copy Account")
                  ])
                : _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Add Account")
                  ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  ref: "dismisModal",
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close"
                  }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12 col-lg-6 col-xl-6 d-flex" },
                  [
                    _c("div", { staticClass: "card flex-fill" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("h4", { staticClass: "card-title" }, [
                          _vm._v("Content Publishing")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "statistics" }, [
                          _c("p", { staticClass: "text-muted" }, [
                            _vm._v(
                              "You can use the Instagram Graph API to publish single images, videos, reels (i.e. single media posts), or posts containing multiple images and videos (carousel posts) on Instagram Business accounts."
                            )
                          ]),
                          _vm._v(" "),
                          _c("h4", { staticClass: "card-title" }, [
                            _vm._v("Limitations")
                          ]),
                          _vm._v(" "),
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "router-link",
                                {
                                  ref: "dismisModal",
                                  attrs: {
                                    "data-dismiss": "modal",
                                    to:
                                      "/instagram/accounts/official/add/content_publishing"
                                  }
                                },
                                [
                                  _c("i", { staticClass: "la la-user" }),
                                  _vm._v(" Add Account\n                    ")
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12 col-lg-6 col-xl-6 d-flex" },
                  [
                    _c("div", { staticClass: "card flex-fill" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("h4", { staticClass: "card-title" }, [
                          _vm._v("Full Access")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "statistics" }, [
                          _c("p", { staticClass: "text-muted" }, [
                            _vm._v(
                              "Allows Instagram Professionals — Businesses and Creators — to manage its presence on Instagram, find hashtagged media, and get basic metadata and metrics about other Instagram Businesses and Creators."
                            )
                          ]),
                          _vm._v(" "),
                          _c("h4", { staticClass: "card-title" }, [
                            _vm._v("Before You Start")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-muted" }, [
                            _vm._v("You will need access to the following:")
                          ]),
                          _vm._v(" "),
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "router-link",
                                {
                                  ref: "dismisModal",
                                  attrs: {
                                    "data-dismiss": "modal",
                                    to:
                                      "/instagram/accounts/official/add/full_access"
                                  }
                                },
                                [
                                  _c("i", { staticClass: "la la-user" }),
                                  _vm._v(" Add Account\n                    ")
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "text-muted" }, [
      _c("li", [_vm._v("Instagram Creator accounts are not supported.")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Accounts are limited to 25 API-published posts within a 24 hour period. Carousels count as a single post."
        )
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("JPEG is the only image format supported.")]),
      _vm._v(" "),
      _c("li", [_vm._v("Stories are not supported.")]),
      _vm._v(" "),
      _c("li", [_vm._v("Shopping tags are not supported.")]),
      _vm._v(" "),
      _c("li", [_vm._v("Publishing to Instagram TV is not supported.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _vm._v("\n                      An\n                      "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://help.instagram.com/502981923235522?fbclid=IwAR0QyyjxqL0PT8WxFogNeNakz1xuvKYmGh53QeqT3IhNhAx3enUUPPL47TE",
              target: "_blank",
              rel: "noopener nofollow",
              "data-lynx-mode": "asynclazy",
              "data-lynx-uri":
                "https://l.facebook.com/l.php?u=https%3A%2F%2Fhelp.instagram.com%2F502981923235522%3Ffbclid%3DIwAR0QyyjxqL0PT8WxFogNeNakz1xuvKYmGh53QeqT3IhNhAx3enUUPPL47TE&h=AT3wxMg8_QOoZLOWSDy5Y5ytcMUQDoH_bRCycjha8Pd7dcKMgDHqwvmi1rMquN0a6bgYH1C3wStngFfzQwCcQqS13wv5iFZlvTO-uWVPmUcyXXj4_1VdHdGYmBZtSSHVEqPMuMNdJEY"
            }
          },
          [_vm._v("Instagram Business Account")]
        ),
        _vm._v(" or\n                      "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://help.instagram.com/1158274571010880?fbclid=IwAR0iKSP5MVPR5-3oxn3N3iNuLf4I3TVEEf8MnumHa4uUsedlxMzCB-MHIZs",
              target: "_blank",
              rel: "noopener nofollow",
              "data-lynx-mode": "asynclazy",
              "data-lynx-uri":
                "https://l.facebook.com/l.php?u=https%3A%2F%2Fhelp.instagram.com%2F1158274571010880%3Ffbclid%3DIwAR0iKSP5MVPR5-3oxn3N3iNuLf4I3TVEEf8MnumHa4uUsedlxMzCB-MHIZs&h=AT0T1h-Cl5r2zGniRgPnUvf61PcucFdUDWxcCx63nhpI38PJZy0rXKiDx1TcSd4s28ZbVOJ94cjLzskJ6JGABKf8xC1BZiWsxno_yj9DnW8kgFap59iCBmSK8mIGverB4BnK0LQLWx0"
            }
          },
          [_vm._v("Instagram Creator Account")]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("\n                      A\n                      "),
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href:
                "https://developers.facebook.com/docs/instagram-api/overview#pages"
            }
          },
          [_vm._v("Facebook Page connected to that account")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6adc497c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6adc497c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/instagram/instagramAccount/formOfficial.vue
// module id = null
// module chunks = 